
export default {
  props: {
    enabled: { type: Boolean, default: false },
  },

  data: () => ({
    optedIn: false,
    showDetails: false,
  }),

  watch: {
    enabled: {
      handler() {
        this.bootstrap();
      },
      immediate: true,
    },
    optedIn() {
      this.persistSelection();
    },
  },

  beforeDestroy() {
    this.$store.dispatch("pdp/resetBespokeSelection");
  },

  methods: {
    bootstrap() {
      this.$store.dispatch("pdp/resetBespokeSelection");
      if (!this.enabled) {
        return;
      }
      this.optedIn = false;
      this.showDetails = false;
      this.persistSelection();
    },
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    persistSelection() {
      if (!this.enabled) {
        return;
      }
      const payload = {
        optIn: this.optedIn,
        summary: this.buildSummary(),
      };
      this.$store.dispatch("pdp/setBespokeSelection", payload);
    },
    buildSummary() {
      return this.optedIn ? "Bespoke customisation requested" : "";
    },
    handleOptInChange(status) {
      this.optedIn = status;
    },
  },
};
